module.exports = __webpack_public_path__ + "static/logo_color.21f45cf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_color.svg
// module id = 292
// module chunks = 14943580662024